import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { FavoriteIcon } from '@Components/UI/Icons';
import { overlays } from 'seal-ui-components';
import { getBaseTheme } from '@Themes';

const { Tooltip } = overlays;

const { focus } = getBaseTheme().colors.control;

const FavoriteIconButton = styled.button`
    padding: 0;
    border: 0;
    background-color: transparent;
    cursor: pointer;

    &:hover {
        .svg-border {
            fill: ${focus.complementaryForegroundColor};
        }
    }
`;

export const FavoriteButton = ({ className, logicAppName, options, onClick }) => {
    const [isFav, setIsFav] = useState(options[logicAppName].isFavorite);
    const favRef = useRef();

    useEffect(() => {
        const { current } = favRef;

        const toggleFavorite = async ev => {
            ev.stopPropagation();
            await onClick(options[logicAppName], isFav);
            setIsFav(!isFav);
        };

        current.addEventListener('click', toggleFavorite);

        return () => {
            current.removeEventListener('click', toggleFavorite);
        };
    });

    return (
        <Tooltip placement="left" content={isFav ? 'Remove from favorites' : 'Mark as favorite'}>
            <FavoriteIconButton ref={favRef} data-testid={`${logicAppName}_favorite`}>
                <FavoriteIcon className={className} isFav={isFav} />
            </FavoriteIconButton>
        </Tooltip>
    );
};
